export const getCopyYear = (): string => {
  const now = new Date();
  return now.getFullYear().toString();
};
